import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Import BrowserRouter, Route, and Routes
import NavigationBar from './components/NavigationBar'; // Renamed Header to NavigationBar
import Banner1 from './components/Banner1';
import ServiceStats from './components/ServiceStats';
import AboutUs from './components/AboutUs';
import ContactForm from './components/Contact';
import Banner from './components/Banner';
import Vision from './components/vision';
import HotMeltAdhesive from './components/Services'; // Import new components
import WaterBasedAdhesive from './components/Services1';
import Footer from './components/Footer';
import Applications from './components/Applications';
import Applications1 from './components/Applications1';

function App() {
  return (
    <Router>
      <div className="app-container">
        <NavigationBar />
        <Routes>
          {/* Main Routes */}
          <Route path="/" element={<><Banner /><Banner1 /><ServiceStats /><HotMeltAdhesive /><Applications /><WaterBasedAdhesive /><Applications1 /><AboutUs /><Vision /><ContactForm /><Footer /></>} />
          
          {/* Submenu Routes */}
          <Route path="/hot-melt-adhesive" element={<><HotMeltAdhesive /><Applications /><Footer /></>} />
          <Route path="/water-based-adhesive" element={<><WaterBasedAdhesive /><Applications1 /><Footer /></>} />
          <Route path="/choose-us" element={<div style={{ marginTop: '150px' }}><ServiceStats/><Footer /></div>} />
          <Route path="/vision" element={<div style={{ marginTop: '80px' }}><Vision /><Footer /></div>} />
          <Route path="/about-us" element={<div style={{ marginTop: '80px' }}><AboutUs /><Footer /></div>} />
          <Route path="/contact-us" element={<div style={{ marginTop: '80px' }}><ContactForm /><Footer /></div>} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
